import { useStateStore } from '$tablet-app/src/app/stores/useStateStore';

export const useDismissChatItemDialog = () =>
  useStateStore((state) => state.clearDisplayedDynamicItem);
